// Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.
import * as React from 'react';
/**
 * A functional tsx component for a text item.
 */
export function TextItem(props) {
    const { title, source, className, ...rest } = props;
    return (React.createElement("span", { className: className
            ? `jp-StatusBar-TextItem ${className}`
            : 'jp-StatusBar-TextItem', title: title, ...rest }, source));
}
//# sourceMappingURL=text.js.map